module.exports = __webpack_public_path__ + "static/media/af.53193f9a.svg";